<app-modal [modalTitle]="'CHOOSE_CORPORATE_TEMPLATE' | translate" [modalId]="'documentTemplate'">
  <div modalBody> <app-document-folder-tree (selectedFolderHiearachy)="getSelectedFolderHiearachy()" [data]="templates"></app-document-folder-tree></div>
  <div class="folder-tree-footer" modalFooter>
    <button
      class="btn btn-primary btn-md btn-style"
      id="new-folder-btn"
      [disabled]="!commonService.selectedTemplate"
      data-bs-toggle="modal"
      data-bs-target="#createEmptyDocumentModal"
      >{{ 'CHOOSE' | translate }}</button
    >
    <div class="modal-footer__right-actions"> </div>
  </div>
</app-modal>
